/* eslint-disable no-nested-ternary */
import { Col, Row } from 'antd';
import DonutChart from 'Components/common/charts/DonutChart';
import EmptyState from 'Components/common/components/EmptyState';
import React from 'react';
import styled from 'styled-components';
import { ISeriesDataType } from 'Types/CommonTypes';
import { SRIUserScore } from 'Types/SRITypes';
import { boxShadow } from 'Utils/utilsStyle';
import ChartSpinner from './ChartSpinner';
import ScoreStatsTip from './ScoreStatsTip';

const Wrapper = styled.div`

`;

const ScoreBreakDown = styled.div`
  padding: 24px 42px;
  box-shadow: ${boxShadow};
  border-radius: 16px;
  background: #fff;
  margin-bottom: 40px;
  .highcharts-background {
    display: flex;
    justify-content: center;
    width: 100%;
  }
`;

const StatsTipWrapper = styled.div`
  margin-top: 40px;
`;

type Props = {
  loading: boolean;
  userScore: SRIUserScore;
  userScoreGraph: ISeriesDataType[];
  title?: string;
} | typeof defaultProps;

const defaultProps = {
  loading: false,
  userScore: {} as SRIUserScore,
  userScoreGraph: [] as ISeriesDataType[],
  title: '',
};

const UserScoreCard = function UserScoreCard(props: Props) {
  const {
    loading, userScore, userScoreGraph, title,
  } = props;
  return (
    <Wrapper>

      <ScoreBreakDown>
        <div className="head-wrap d-flex justify-content-between mb-c-30">
          <h6 className="title mb-0">{title}</h6>
        </div>
        <Row>
          {
            loading
              ? <ChartSpinner />
              : userScore?.results?.length === 0 && !loading ? (
                <EmptyState
                  msg="No analytics data found"
                  detail="Try adjusting your filters to find what you are looking for"
                  height="330px"
                />
              )
                : (
                  <>
                    <Col span={10}>
                      <StatsTipWrapper>
                        {userScore?.results && userScore?.results.map(
                          (item) => (
                            <ScoreStatsTip
                              color={item.color}
                              title={item.name}
                              stats={item.count}
                              pts={item.score}
                            />
                          ),
                        )}
                      </StatsTipWrapper>
                    </Col>
                    <Col span={14}>
                      <DonutChart
                        data={userScoreGraph}
                        height={400}
                        width={600}
                      />
                    </Col>
                  </>
                )
          }
        </Row>
      </ScoreBreakDown>
    </Wrapper>
  );
};

UserScoreCard.defaultProps = defaultProps;
export default UserScoreCard;
